<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import { avatarDelete } from "@/common/api/rest/console/avatar";

import { consolePatch } from "@/common/api/rest/console/console";

import type { ConsoleType } from "@/common/types/console/console";
import type { TranslationFieldsType } from "@/common/types/translation";

import { FormConsole, ListTranslate } from "@/components";

import { baseAvatar, baseConfirm } from "@/common/components";

const { t, locale } = useI18n();
const route = useRoute();

const emit = defineEmits(["update:data"]);

const props = defineProps<{
  console: ConsoleType | null;
  consoleId: string;
}>();

const showAvatarDel = ref(false);

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    label: "common.labels.name",
    value: "",
  },
  {
    type: "textarea",
    field: "description",
    label: "common.labels.description",
    value: "",
  },
]);

const type = computed(() => route.params.type as string);

function patchData(payload: Partial<ConsoleType>) {
  consolePatch(props.consoleId, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        // emit("update:data");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// AVATAR
function delAvatar() {
  showAvatarDel.value = true;
}

function delAvatarConfirm() {
  if (!props.console?.avatar) {
    return;
  }

  store.commit("SET_LOADING", true);

  avatarDelete(props.consoleId)
    .then((response) => {
      const { success, message } = response;

      toast({ message: message, type: success ? "success" : "error" });

      emit("update:data");
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      showAvatarDel.value = false;
      store.commit("SET_LOADING", false);
    });
}
</script>

<template>
  <div class="flex justify-center">
    <base-avatar
      position="center"
      size="15rem"
      :is-edit="true"
      :show-edit="false"
      :show-upload="false"
      :show-image="true"
      :url="props.console?.avatar?.large"
      :aspect-ratio="1"
      border-radius="0.5rem"
      @del="delAvatar()"
    />
  </div>

  <form-console
    :data="props.console"
    :type="type"
    :is-patch="true"
    @update:data="patchData($event)"
  />

  <list-translate
    :owner-id="consoleId"
    :language="locale.toLowerCase()"
    :fields="translationFields"
  />

  <base-confirm
    :show="showAvatarDel"
    :title="t('common.modals.titles.remove_image').toUpperCase()"
    :message="t('common.modals.messages.remove_image')"
    @cancel="showAvatarDel = false"
    @confirm="delAvatarConfirm()"
  />
</template>
